import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

import ViewOnPath from '../../image/ViewOn.png';
import ViewOffPath from '../../image/ViewOff.png';
import { useLanguage } from '../../Context/LanguageContext';

const SignUpPwInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn } = props;
	const { t } = useLanguage();
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [clickView, setClickView] = useState(true);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);
	const [isInvalidPw, setIsInvalidPw] = useState(false);

	const BorderRef = useRef();
	const inputRef = useRef();
	const ViewButtonRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			BorderRef.current.style.borderColor = '#FF3131';
			inputRef.current.style.borderColor = '#FF3131';
			ViewButtonRef.current.style.borderColor = '#FF3131';
		},
		isValidPassword: () => {
			const pw = value;

			if (pw === '') {
			setIsInvalidPw(true);
			setDefaultPlaceholder(t('signUp.pwRequired'));
			BorderRef.current.style.borderColor = '#FF3131';
			return false;
			}

			if (!isValidPassword(pw)) {
			setIsInvalidPw(true);
			setDefaultPlaceholder(t('signUp.pwFormatError'));
			BorderRef.current.style.borderColor = '#FF3131';
			return false;
			}

			setIsInvalidPw(false);
			return true;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			BorderRef.current.style.borderColor = '#E8E8E8';
			inputRef.current.style.borderColor = '#E8E8E8';
			ViewButtonRef.current.style.borderColor = '#E8E8E8';
		} 
	}));

	useEffect(() => {
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	function handleClick(e) {
		BorderRef.current.style.borderColor = '#FF3131';
		inputRef.current.style.borderColor = '#FF8B48';
		ViewButtonRef.current.style.borderColor = '#FF8B48';
		setDefaultPlaceholder('');
	}

	function handleChange(e) {
		const val = e.target.value;
		setValue(val);
		setChanged(true);

		if (val === '') {
			setIsInvalidPw(false);
			return;
		}

		if (!isValidPassword(val)) {
			setIsInvalidPw(true);
			BorderRef.current.style.borderColor = '#FF3131';
			ViewButtonRef.current.style.borderColor = '#FF3131';
		}
		else {
			setIsInvalidPw(false);
			BorderRef.current.style.borderColor = '#E8E8E8';
			ViewButtonRef.current.style.borderColor = '#E8E8E8';
		}
	}

	function handleFocus(e) {
		if (changed) {
			// do nothing
		}
		else {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);

		if (!isInvalidPw && isValidPassword(value)) {
			BorderRef.current.style.borderColor = '#E8E8E8'; // 정상 회색
			ViewButtonRef.current.style.borderColor = '#E8E8E8';
		}
	}

	function isValidPassword(pw) {
		if (pw.length < 6) return false;
		if (!/[A-Za-z]/.test(pw)) return false;      // 영문
		if (!/[0-9]/.test(pw)) return false;         // 숫자
		if (!/[!@#$%^&*(),.?":{}|<>]/.test(pw)) return false; // 특수문자
		return true;
	}

	return (
		<TopLevelWrapper ref={BorderRef}>
			<Input
				ref={inputRef}
				clickCount={clickCount}
				type={clickView ? 'password' : 'text'}
				placeholder={defaultPlaceholder}
				value={value}
				className={`${className} ${changed ? "changed" : ""}`}
				onClick={handleClick}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur} />
			<ViewButtonWrapper ref={ViewButtonRef} onClick={() => (clickView ? setClickView(false) : setClickView(true))}>
				<ViewIcon src={clickView ? ViewOnPath : ViewOffPath}/>
				<ViewButton clickView={clickView}>{clickView ? t('signUp.showPassword') : t('signUp.hidePassword')}</ViewButton>
			</ViewButtonWrapper>
		</TopLevelWrapper>
	)
});

export default SignUpPwInput;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: space-between;
	align-items: flex-end;

	width: 100%;
	
	border-bottom: 1px solid #E8E8E8;

  transition: all 0.5s ease-in-out;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	padding: 0 0 4px 0;
	margin-top: 10px;
	// margin-top: max(12px, 0.8333333333333333vw);

	// width: 72%;
	// width: max(157px, 18.90625vw);
	width: 363px;
	// background-color: blue;
	outline: none;
	border: 0px;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	// color: #000000;

	::placeholder {
		color: ${props => props.clickCount < 1 || props.value !== '' ? `#CBCBCB` : `#FF3131;`};
	}
	
  transition: all 0.5s ease-in-out;
`;

const ViewButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: flex-start;
	align-items: center;

	// width: 200px;
	// background-color: red;
	// width: max(93px, 5.46875vw);
	width: 121px;
	// height: 76%;105
	
	// border: solid;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
  // transition: all 0.5s ease-in-out;
	overflow: hidden;

	&:hover {
		cursor: pointer;
	}
`;

const ViewIcon = styled.img`
	width: 20px;
	height: 20px;

	margin: 0 4px 4px 0;
`;

const ViewButton = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;

	margin: 0 0 4px 0;

	color: #FF8B48;
`;